import { AnimatePresence, motion } from "framer-motion";
import React, { useEffect, useRef } from "react";
import { LiaTimesSolid } from "react-icons/lia";
import cn from "../../../lib/cn";

const BottomDrawer = ({
    isOpen,
    onClick,
    className,
    showClose = true,
    children,
    contentClass,
    childrenClassName,
}) => {
    const ref = useRef();

    const handleContainerClicked = (e) => {
        if (!ref.current.contains(e.target)) {
            onClick(false);
        }
    };

    useEffect(() => {
        // document.body.style.overflowY = isOpen ? "hidden" : "unset";
    }, [isOpen]);

    return (
        <AnimatePresence>
            {isOpen && (
                <motion.div
                    className={cn(
                        "fixed left-0 bottom-0 right-0 bg-black/70  h-full pt-[105px] flex items-end w-full z-50",
                        className
                    )}
                    role="button"
                    onClick={handleContainerClicked}
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    transition={{ duration: 0.3, ease: "easeInOut" }}
                >
                    <motion.div
                        className={cn(
                            "w-full rounded-t-2  max-h-[80vh] overflow-y-hidden  overflow-x-hidden relative pb-2 flex flex-col",
                            contentClass
                        )}
                        ref={ref}
                        initial={{ y: "100%" }}
                        animate={{ y: 0 }}
                        exit={{ y: "100%" }}
                        transition={{ duration: 0.3, ease: "easeInOut" }}
                    >
                        {showClose && (
                            <div className="flex justify-end">
                                <button
                                    type="button"
                                    onClick={() => onClick(false)}
                                    className="h-3 w-3 mr-1 my-1  rounded-full bg-gray-160  flex items-center justify-center text-primary text-xl"
                                >
                                    <LiaTimesSolid size={25} />
                                </button>
                            </div>
                        )}
                        <div
                            className={cn(
                                "flex-1 overflow-y-auto ",
                                childrenClassName
                            )}
                        >
                            {children}
                        </div>
                    </motion.div>
                </motion.div>
            )}
        </AnimatePresence>
    );
};

export default BottomDrawer;
